import { CloseOutlined } from "@ant-design/icons";
import { InfoWindow } from "@react-google-maps/api";
import { Col, Image, Row, Tooltip, Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import PriceFormatter from "apps/Common/PriceFormatter";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetShowMarkerTooltip } from "../ClientStates";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import CardItemCarouselIndex from "apps/RealState/Common/CardItemCarouselIndex";
import AdvertOptions from "apps/RealState/Common/AdvertOptions";
import useCapitalize from "apps/Common/Adress/helpers/useCapitalize";
import NoImageSmall from "assets/Images/no_image_card.webp";
import { FallbackObj } from "helpers/ImageFallBack";
const InfoWindowItem = () => {
  const { Text } = Typography;
  const { capitalize } = useCapitalize();
  const dispatch = useDispatch();
  const { selectedMarkerItemData: data } = useSelector(
    (state: RootState) => state.mapList
  );
  const location = `${data?.neighbourhood?.name || ""} ${
    data?.district?.name || ""
  } ${data?.city?.name || ""}`;

  return (
    <InfoWindow
      position={{
        lat: Number(data?.latitude),
        lng: Number(data?.longitude),
      }}
      onCloseClick={() => {
        dispatch(handleSetShowMarkerTooltip({ status: false }));
      }}
    >
      <>
        <Col xs={24} className="!overflow-hidden !h-full">
          <div className="!flex justify-end">
            <CloseOutlined
              className="!text-gray-400 hover:cursor-pointer"
              onClick={() => {
                dispatch(handleSetShowMarkerTooltip({ status: false }));
              }}
            />
          </div>

          <div className="!p-2 !w-full">
            <Image
              className=" !h-[200px] !w-full"
              wrapperClassName="!w-full"
              src={
                data?.advertMedia[0]?.media?.fullPath
                  ? `${setBackEndUlr()}/${
                      data?.advertMedia[0]?.media?.fullPath
                    }`
                  : NoImageSmall
              }
              {...FallbackObj()}
            />
          </div>
        </Col>
        <div className="!grid gap-2">
          <div className="!h-[20px]">
            <Row className="!flex items-center">
              <Col xs={24}>
                <Text className="!font-bold !text-[20px] !text-[#3b4144] ">
                  <PriceFormatter
                    inputPrice={data.price}
                    currency={data?.currency?.shortName}
                  />{" "}
                </Text>
              </Col>
            </Row>
          </div>

          <div className="!h-[45px]">
            {data.title?.length <= 97 ? (
              <>
                <Text className="!text-[16px] !text-[#3b4144]">
                  {capitalize(data.title)}
                </Text>
              </>
            ) : (
              <>
                <Tooltip title={data.title}>
                  <Text className="!text-[16px] !text-[#3b4144]">
                    {capitalize(data.title.slice(0, 97))}
                  </Text>
                </Tooltip>
              </>
            )}
          </div>
          <div className="!h-[18px]">
            {location.length <= 64 ? (
              <>
                <Text
                  className="!text-[#7a868e] !text-xs "
                  style={{ lineHeight: "0 !important" }}
                >
                  {location}
                </Text>
              </>
            ) : (
              <>
                <Tooltip title={location}>
                  <Text
                    className="!text-[#7a868e] !text-xs "
                    style={{ lineHeight: "0 !important" }}
                  >
                    {location?.slice(0, 64)}
                  </Text>
                </Tooltip>
              </>
            )}
          </div>
          <div>
            <div>
              {data.cardViewAdvertOptions && (
                <>
                  <AdvertOptions
                    options={data.cardViewAdvertOptions}
                    type={data.type}
                  />
                </>
              )}
            </div>
          </div>
          <div className="!flex items-center gap-6">
            <div className="!flex items-center gap-1">
              {data.store?.photoUrl && (
                <Image
                  width="50px"
                  height="50px"
                  src={setBackEndUlr() + "/" + data.store.photoUrl}
                  alt=""
                  className="!rounded-md"
                  preview={false}
                  {...FallbackObj()}
                />
              )}
              <div>
                {data.store?.storeName && (
                  <>
                    <div>
                      <Text className="!text-black">
                        {data.store?.storeName}
                      </Text>
                    </div>
                  </>
                )}

                <div>
                  <Text className="!text-gray-400 !text-xs">
                    {`${data?.user?.name || ""} ${data?.user?.surname || ""}`}
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </InfoWindow>
  );
};

export default InfoWindowItem;
